import '../scss/style-personal.scss';
import bootstrap from 'bootstrap';
import SmoothScroll from 'smooth-scroll';
import $ from "jquery";
import {gsap, Power2} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import LazyLoad from "vanilla-lazyload";

//Smooth scroll anchor
var scrollS = new SmoothScroll('a[href*="#"]', {
	speed: 500,
	speedAsDuration: true
});

//Sticky header
window.addEventListener('scroll', function () {
    const headerSticky = document.querySelector(".navbar-sticky");
    const coords = 10;
    if (headerSticky) {
       headerSticky.classList.toggle("is-sticky", window.scrollY > coords)
    }
 });

 //Interactive image bounce
 function initStickyCursorWithDelay() {
   var cursorImage = $(".interactive-list-image")
   var cursorBtn = $(".interactive-mouse-btn");
   var cursorSpan = $(".interactive-mouse-span");
 
   var posXImage = 0
   var posYImage = 0
   var posXBtn = 0
   var posYBtn = 0
   var posXSpan = 0
   var posYSpan = 0
   var mouseX = 0
   var mouseY = 0
 
   if(document.querySelector(".interactive-list-image, .interactive-mouse-btn, .interactive-mouse-span")) {
   gsap.to({}, 0.0083333333, {
     repeat: -1,
     onRepeat: function() {
 
       if(document.querySelector(".interactive-list-image")) {
         posXImage += (mouseX - posXImage) / 12;
         posYImage += (mouseY - posYImage) / 12;
         gsap.set(cursorImage, {
           css: {
           left: posXImage,
           top: posYImage
           }
         });
       }
       if(document.querySelector(".interactive-mouse-btn")) {
         posXBtn += (mouseX - posXBtn) / 7;
         posYBtn += (mouseY - posYBtn) / 7;
         gsap.set(cursorBtn, {
           css: {
           left: posXBtn,
           top: posYBtn
           }
         });
       }
       if(document.querySelector(".interactive-mouse-span")) {
         posXSpan += (mouseX - posXSpan) / 6;
         posYSpan += (mouseY - posYSpan) / 6;   
         gsap.set(cursorSpan, {
           css: {
           left: posXSpan,
           top: posYSpan
           }
         });
       }
     }
   });
   }
 
   $(document).on("mousemove", function(e) {
     mouseX = e.clientX;
     mouseY = e.clientY;
   });
   $('.interactive-list-image-wrap a').on('mouseenter', function() {
     $('.interactive-list-image, .interactive-mouse-btn, .interactive-mouse-span, .interactive-list-mouse-big').addClass('active');
   });
   $('.interactive-list-image-wrap a').on('mouseleave', function() {
     $('.interactive-list-image, .interactive-mouse-btn, .interactive-mouse-span, .interactive-list-mouse-big').removeClass('active');
   });
   $('.interactive-tiles a').on('mouseenter', function() {
     $('.interactive-mouse-btn, .interactive-mouse-span').addClass('active-big');
   });
   $('.interactive-tiles a').on('mouseleave', function() {
     $('.interactive-mouse-btn, .interactive-mouse-span').removeClass('active-big');
   });
   $('main').on('mousedown', function() {
     $(".interactive-mouse-btn, .interactive-mouse-span").addClass('pressed');
   });
   $('main').on('mouseup', function() {
     $(".interactive-mouse-btn, .interactive-mouse-span").removeClass('pressed');
   });
 
   $('.interactive-list-image-wrap li.visible').on('mouseenter', function() {
     
     var $elements = $(".interactive-list-image-wrap li.visible");
     var index =  $elements.index($(this));
     var count = $(".interactive-list-image li.visible").length;
     // var index =  $(this).index();
     if($(".interactive-float-image-wrap")) {
         gsap.to($(".interactive-float-image-wrap"), {
           y: (index*100)/(count*-1) + "%",
           duration: .6,
           ease: Power2.easeInOut
         });
     }
     $(".interactive-list-image.active .interactive-list-image-bounce").addClass("active").delay(400).queue(function(next){
         $(this).removeClass("active");
         next();
     });
 
   });
 
 } initStickyCursorWithDelay();
 
 function initLazyLoad() {
     var lazyLoadInstance = new LazyLoad({ 
       elements_selector: ".lazy",
     });
 
 }initLazyLoad();


//Aos animation + Countup on aos-init
const AOS = require('aos');
import { CountUp } from 'countup.js';

AOS.init({
  startEvent: 'load',
  duration: 900,
  delay: 50,
  once: true
});
function countIt(el) {
  const Num = el.dataset.to ? +el.dataset.to : null,
    n = el.dataset.countup ? JSON.parse(el.dataset.countup) : {};
  new CountUp(el, Num, n).start()
};
document.querySelectorAll("[data-countup]").forEach(el => { "countup:in" !== el.getAttribute("data-aos-id") && countIt(el) }),
  document.addEventListener("aos:in:countup:in", (function (el) {
    (
      el.detail instanceof Element ? [el.detail] : document.querySelectorAll('.aos-animate[data-aos-id="countup:in"]')).forEach(el => { countIt(el) })
  }));

  //Rellax 
  import Rellax from 'rellax';
    new Rellax('[data-parallax]');


    //Lightbox bigpicture
    const BigPicture = require('bigpicture');
var elLightbox = document.querySelectorAll('[data-bigpicture]');
  elLightbox.forEach((
    function (e) {
      e.addEventListener("click", (function (t) {
        t.preventDefault();
        const n = JSON.parse(e.dataset.bigpicture),
          o = { ...{ el: e, noLoader: !0 }, ...n };
       new BigPicture(o)
      }
      ))
    }));